module.exports = __webpack_public_path__ + "img/param.469ca42b.png";